"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const responsive_1 = require("./responsive");
const cards = {
    light: {
        card: { background: 'white', borderRadius: 8, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' },
        title: '#333',
        dim: '#9ca3af',
        badge: '#667eea',
    },
    // Secret Shop's dark/gold theme.
    dark: {
        card: { background: '#15151c', border: '1px solid rgba(201,169,98,0.25)', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.35)' },
        title: '#f2ede2',
        dim: '#9a9488',
        badge: '#c9a962',
    },
};
function CollapsibleSection({ title, badge, defaultOpen = false, storageKey, open: controlledOpen, onOpenChange, variant = 'light', style, children, }) {
    const [storedOpen, setStoredOpen] = (0, responsive_1.useSessionState)(storageKey ? `collapse:${storageKey}` : undefined, defaultOpen);
    const isControlled = controlledOpen !== undefined;
    const open = isControlled ? controlledOpen : storedOpen;
    const toggle = () => {
        if (isControlled)
            onOpenChange?.(!open);
        else {
            setStoredOpen(!open);
            onOpenChange?.(!open);
        }
    };
    const c = cards[variant];
    return ((0, jsx_runtime_1.jsxs)("div", { style: { ...c.card, marginBottom: 20, overflow: 'hidden', ...style }, children: [(0, jsx_runtime_1.jsxs)("button", { type: "button", onClick: toggle, "aria-expanded": open, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 12,
                    width: '100%',
                    minHeight: 56,
                    padding: '16px 20px',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: 17,
                    fontWeight: 700,
                    color: c.title,
                }, children: [(0, jsx_runtime_1.jsxs)("span", { style: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', minWidth: 0 }, children: [title, badge !== undefined && badge !== null && badge !== '' && ((0, jsx_runtime_1.jsx)("span", { style: { fontSize: 13, fontWeight: 600, color: c.badge }, children: badge }))] }), (0, jsx_runtime_1.jsx)("span", { "aria-hidden": true, style: {
                            color: c.dim,
                            fontSize: 14,
                            display: 'inline-block',
                            transition: 'transform 0.15s',
                            transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
                        }, children: "\u25BE" })] }), open && (0, jsx_runtime_1.jsx)("div", { style: { padding: '0 20px 20px', color: c.title }, children: children })] }));
}
exports.CollapsibleSection = CollapsibleSection;
exports.default = CollapsibleSection;
